<p
  [innerHtml]="
    'ONSIP_I18N.ADD_HOLIDAYS_DATES_THAT_YOU_WILL_BE_CLOSED_THIS_STRONGSAYSOSTRONG_TOPIC_WILL_NOT_APPEAR_FROM_MIDNIGHT_TO_MIDNIGHT_ON_THE_DAY_LISTED'
      | translate
  "
></p>
@for (holiday of holidayArray.controls; track holiday; let i = $index) {
<div>
  <form [formGroup]="holiday">
    <div class="holiday-line">
      <mat-form-field appearance="outline" class="holiday-name">
        <mat-label>{{ "ONSIP_I18N.HOLIDAY_NAME" | translate }}</mat-label>
        <input
          matInput
          #holidayNameInput
          autocomplete="off"
          maxlength="24"
          formControlName="label"
        />
        <mat-hint align="end">{{ holidayNameInput.value.length }} / 24</mat-hint>
        <mat-error>{{ getNameInputErrors(holiday) }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="holiday-date-select">
        <mat-select placeholder="mm" formControlName="m">
          @for (a of Arr(12).fill(1); track a; let month = $index) {
          <mat-option [value]="month">{{ month + 1 }}</mat-option>
          }
        </mat-select>
        <mat-label>{{ "ONSIP_I18N.MONTH" | translate }}</mat-label>
        <mat-error>{{ getDateInputErrors(holiday) }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="holiday-date-select">
        <mat-select placeholder="dd" formControlName="d">
          @switch (true) {
          <!-- DYNAMIC DATE OPTIONS BASED ON MONTH -->
          @case (holiday.value['m'] === 1) { @for (a of Arr(29).fill(1); track a; let date = $index)
          {
          <mat-option [value]="date + 1">{{ date + 1 }}</mat-option>
          } } @case ( holiday.value['m'] === 3 || holiday.value['m'] === 5 || holiday.value['m'] ===
          8 || holiday.value['m'] === 10) { @for (a of Arr(30).fill(1); track a; let date = $index)
          {
          <mat-option [value]="date + 1">{{ date + 1 }}</mat-option>
          } } @default { @for (a of Arr(31).fill(1); track a; let date = $index) {
          <mat-option [value]="date + 1">{{ date + 1 }}</mat-option>
          } } }
        </mat-select>
        <mat-label>{{ "ONSIP_I18N.DATE" | translate }}</mat-label>
        <mat-error>{{ getDateInputErrors(holiday) }}</mat-error>
      </mat-form-field>
      <button type="button" mat-icon-button color="primary" (click)="deleteHoliday(i)">
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
  </form>
</div>
}
<button type="button" mat-button color="primary" (click)="addHoliday()">
  <mat-icon>add</mat-icon>{{ "ONSIP_I18N.ADD_HOLIDAY" | translate }}
</button>
